let inject = [

  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings',
  '$filter'
];

class CategoriessliderFilterController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings,$filter) {
    this.$state = $state;
    this.$scope = $scope;
    this.$filter = $filter;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;

    this.status ={
      open:false
    };
    this.customFilters = {
      productHighPrice : 100,
      productLowPrice : 1000,
      productHighPriceTest : 1000,
      productLowPriceTest : 100
    };

    this.sliderOptions = {
      options : {
        showSelectionBar: true,
        floor: 0,
        step: 1,
        minRange: 10,
        ceil: 100,
        noSwitching: true,
      }
    };


    this.groups = [
      {
        title: 'Group Header - 1',
        content: 'Group Body - 1'
      },
      {
        title: 'Group Header - 2',
        content: 'Group Body - 2'
      }
    ];
    this.oneAtATime = true;
    this.categoryPimary = [];
  }

  $onInit(){
    if(this.sisters){
      this.items=this.sisters
    }else{
      this.items=this.shCtrl.globalCategoriesMenu[0].hijas;
    }
    this.cargarCategoriaPrincipal();
  }

  cargarCategoriaPrincipal(){
    try{
      if(this.company){
        if(this.shCtrl.globalCategoriesMenu[0].company == this.company){
          this.categoryPimary = this.shCtrl.globalCategoriesMenu[0];
        }else if(this.shCtrl.globalCategoriesMenu[1].company == this.company){
          this.categoryPimary = this.shCtrl.globalCategoriesMenu[1];
        }
    }
    }catch(e){
      console.log("Error",e);
    }
  }
}

CategoriessliderFilterController.$inject = inject;

export default CategoriessliderFilterController;





// WEBPACK FOOTER //
// ./www/components/catalog/categories-filter/categories-slider-filter/categories-slider-filter.controller.js